import { Navigate, Route, Routes } from "react-router-dom";
import { FRESHMAN_ROUTER_URL, ROUTER_URL } from "../constants/routerUrl";
import StudentDashboard from "../pages/student/dashboard/studentDashboad";
import StudentAcademicProfile from "../pages/student/academicProfile/studentAcademicProfile";
import StudentAccounts from "../pages/student/studentAccount/studentAccounts";
import StudentCourses from "../pages/student/courses/studentCourses";
import FacultyDashboad from "../pages/faculty/dashboard/facultyDashboad";
import FacultyConnect from "../pages/faculty/connect/facultyConnect";
import SendToMail from "../pages/staff/dashboard/components/sendToMail";
import StaffReports from "../pages/staff/StaffReports/staffReports";
import StaffCommunication from "../pages/staff/dashboard/components/staffCommunication";
import FacualtyReports from "../pages/faculty/reports/facualtyReports";
import StaffConnect from "../pages/staff/staffConnect/StaffConnect";
import StaffDashboard from "../pages/staff/dashboard/staffDashboard";
import StaffEmployeeTraining from "../pages/staff/employeeTraining/staffEmployeeTraining";
import CollegeIndex from "../pages/admin/components/masters/college/collegeIndex";
import DepartmentIndex from "../pages/admin/components/masters/department/departmentIndex";
import StudentGrades from "../pages/student/grades/studentGrades";
import StudentCareerPath from "../pages/student/careerPath/studentCareerPath";
import DepartmentAdminFeedback from "../pages/admin/components/departmentAdminFeedback";
import FacultyAllQuickLinks from "../pages/faculty/dashboard/components/viewAll/facultyAllQuickLinks";
import TaskViewAll from "../pages/faculty/dashboard/components/viewAll/taskViewAll";
import AllDailyFacultyReports from "../pages/faculty/reports/components/viewAll/allDailyFacultyReports";
import AllMonthlyFacultyReports from "../pages/faculty/reports/components/viewAll/allMonthlyFacultyReports";
import AllYearlyFacultyReports from "../pages/faculty/reports/components/viewAll/allYearlyFacultyReports";
import PlanYourNextTerm from "../pages/student/dashboard/components/viewAll/planYourNextTerm";
import QuickLinkViewAll from "../pages/student/courses/components/viewAll/quickLinkViewAll";
import ResourceViewAll from "../pages/student/studentAccount/components/viewAll/resourceViewAll";
import HrAndBenifitsViewAll from "../pages/staff/dashboard/components/ViewAll/hrAndBenifitsViewAll";
import FinanceResourceViewAll from "../pages/staff/dashboard/components/ViewAll/financeResourceViewAll";
import TechnologyResourcesViewAll from "../pages/staff/dashboard/components/ViewAll/technologyResourcesViewAll";
import CampusEventsViewAll from "../pages/staff/dashboard/components/ViewAll/campusEventsViewAll";
import CampusSafetyViewAll from "../pages/staff/dashboard/components/ViewAll/campusSafetyViewAll";
import EmployeeTrainingViewAll from "../pages/staff/employeeTraining/components/ViewAll/employeeTrainingViewAll";
import StaffDailyReportsViewAll from "../pages/staff/StaffReports/components/ViewAll/staffDailyReportsViewAll";
import StaffWeeklyReportsViewAll from "../pages/staff/StaffReports/components/ViewAll/staffWeeklyReportsViewAll";
import StaffAnnuallyReportsViewAll from "../pages/staff/StaffReports/components/ViewAll/staffAnnuallyReportsViewAll";
import Notifications from "../common-components/notification";
import CollegeDetails from "../pages/admin/components/masters/college/collegeDetails";
import DepartmentDetails from "../pages/admin/components/masters/department/departmentDetails";
import StudentSendToMail from "../pages/student/navbar/components/studentSendToMail";
import Settings from "../common-components/settings/settings";
import Resources from "../common-components/resources/resources";
import Feedback from "../common-components/feedback/feedback";
import Login from "../pages/login";
import FreshmanProcess from "../pages/freshman/freshmanProcess";
import AdminSettings from "../common-components/settings/adminSettings";
import FreshmanProcessApproval from "../common-components/freshmanProcessApproval";
import BetaDashboard from "../pages/student/dashboard/betaDashboard/betaDashboard";
import HelpInstructions from "../common-components/helpInstructions/helpInstructions";
import ApiKeyConfigurationIndex from "../pages/admin/components/ai/apiKeyConfigurationIndex";

export default function Router() {
  return (
    <Routes>
      <Route path={ROUTER_URL.LOGIN} element={<Login />}></Route>
      <Route path={ROUTER_URL.COLLEGE_INDEX} element={<CollegeIndex />}></Route>
      <Route
        path={ROUTER_URL.COLLEGE_DETAILS}
        element={<CollegeDetails />}
      ></Route>
      <Route
        path={ROUTER_URL.DEPARTMENT_INDEX}
        element={<DepartmentIndex />}
      ></Route>
      <Route
        path={ROUTER_URL.DEPARTMENT_DETAILS}
        element={<DepartmentDetails />}
      ></Route>
      <Route
        path={ROUTER_URL.STUDENT_DASHBOAD}
        element={<StudentDashboard />}
      />
      <Route
        path={ROUTER_URL.FACULTY_DASHBOARD}
        element={<FacultyDashboad />}
      />
      <Route
        path={ROUTER_URL.FACULTY_ALL_QUICK_LINKS}
        element={<FacultyAllQuickLinks />}
      />
      <Route path={ROUTER_URL.FACULTY_ALL_TASKS} element={<TaskViewAll />} />
      <Route
        path={ROUTER_URL.FACULTY_DAILY_REPORTS}
        element={<AllDailyFacultyReports />}
      />
      <Route
        path={ROUTER_URL.FACULTY_MONTHLY_REPORTS}
        element={<AllMonthlyFacultyReports />}
      />
      <Route
        path={ROUTER_URL.FACULTY_YEARLY_REPORTS}
        element={<AllYearlyFacultyReports />}
      />
      <Route path={ROUTER_URL.RESOURCES} element={<Resources />} />
      <Route path={ROUTER_URL.FEEDBACK} element={<Feedback />} />
      <Route path={ROUTER_URL.STAFF_DASHBOARD} element={<StaffDashboard />} />
      <Route path={ROUTER_URL.FACULTY_REPORTS} element={<FacualtyReports />} />
      <Route path={ROUTER_URL.FACULTY_RESOURCES} element={<Resources />} />
      <Route path={ROUTER_URL.FACULTY_CONNECT} element={<FacultyConnect />} />
      <Route
        path={ROUTER_URL.STUDENT_ACADEMIC_PROFILE}
        element={<StudentAcademicProfile />}
      />
      <Route path={ROUTER_URL.STUDENT_ACCOUNTS} element={<StudentAccounts />} />
      <Route
        path={ROUTER_URL.STUDENT_CAREER_PATH}
        element={<StudentCareerPath />}
      />
      <Route path={ROUTER_URL.STUDENT_COURSES} element={<StudentCourses />} />
      <Route path={ROUTER_URL.STUDENT_GRADES} element={<StudentGrades />} />
      <Route path={ROUTER_URL.STAFF_SENDTOMAIL} element={<SendToMail />} />
      <Route
        path={ROUTER_URL.STAFF_ALL_HR_AND_BENIFITS}
        element={<HrAndBenifitsViewAll />}
      ></Route>
      <Route
        path={ROUTER_URL.STAFF_ALL_FINANCE_RESOURCES}
        element={<FinanceResourceViewAll />}
      ></Route>
      <Route
        path={ROUTER_URL.STAFF_ALL_TECHNOLOGY_RESOURCES}
        element={<TechnologyResourcesViewAll />}
      ></Route>
      <Route
        path={ROUTER_URL.STAFF_ALL_CAMPUS_EVENTS}
        element={<CampusEventsViewAll />}
      ></Route>
      <Route
        path={ROUTER_URL.STAFF_ALL_CAMPUS_SAFETY}
        element={<CampusSafetyViewAll />}
      ></Route>
      <Route
        path={ROUTER_URL.STAFF_ALL_EMPLOYEE_TRAINING}
        element={<EmployeeTrainingViewAll />}
      ></Route>
      <Route
        path={ROUTER_URL.STAFF_ALL_DAILY_REPORTS}
        element={<StaffDailyReportsViewAll />}
      ></Route>
      <Route
        path={ROUTER_URL.STAFF_ALL_WEEKLY_REPORTS}
        element={<StaffWeeklyReportsViewAll />}
      ></Route>
      <Route
        path={ROUTER_URL.STAFF_ALL_ANNUALLY_REPORTS}
        element={<StaffAnnuallyReportsViewAll />}
      ></Route>
      <Route
        path={ROUTER_URL.STAFF_TRAINING}
        element={<StaffEmployeeTraining />}
      />
      <Route path={ROUTER_URL.STAFF_REPORTS} element={<StaffReports />} />
      <Route
        path={ROUTER_URL.STAFF_COMMUNICATION}
        element={<StaffCommunication />}
      />
      <Route path={ROUTER_URL.FACULTY_REPORTS} element={<FacualtyReports />} />
      {/* element={<StaffConnect/>} */}
      <Route path={ROUTER_URL.STAFF_CONNECT} element={<StaffConnect />} />
      <Route
        path={ROUTER_URL.STUDENT_SENDTOMAIL}
        element={<StudentSendToMail />}
      />
      <Route path={ROUTER_URL.SETTINGS} element={<Settings />}></Route>
      <Route path={ROUTER_URL.INSTRUCTIONS} element={<HelpInstructions />}></Route>
      <Route path={ROUTER_URL.ADMIN_SETTINGS} element={<AdminSettings />}></Route>

      <Route
        path={ROUTER_URL.SUPER_ADMIN_FEEDBACK}
        element={<DepartmentAdminFeedback />}
      ></Route>
      {/* viewall */}
      <Route
        path={ROUTER_URL.STUDENT_PLAN_NEXT_TERM}
        element={<PlanYourNextTerm />}
      />
      <Route
        path={ROUTER_URL.QUICK_LINKS_VIEW_ALL}
        element={<QuickLinkViewAll />}
      />
      <Route
        path={ROUTER_URL.STUDENT_RESOURCE_VIEW_ALL}
        element={<ResourceViewAll />}
      />
      <Route path={ROUTER_URL.NOTIFICATION} element={<Notifications />} />
      <Route path={ROUTER_URL.FRESHMAN_PROCESS} element={<FreshmanProcess />} />

      <Route path={ROUTER_URL.FRESHMAN_PROCESS_APPROVAL} element={<FreshmanProcessApproval />} />
      <Route path={ROUTER_URL.BETA} element={<BetaDashboard />} />
      <Route path={ROUTER_URL.AI_CONFIGURATION} element={<ApiKeyConfigurationIndex />}></Route>
    </Routes>
  );
}
